import getGenericVendorsData from './getGenericVendorsData';
import React from 'react';
import VendorsCategory from '../VendorsCategory/VendorsCategory';
import VendorsTable from '../VendorsTable/VendorsTable';

export default function GenericVendorsTable() {
	return (
		<React.Fragment>
			<VendorsCategory
				isGettingData={true}
				onSelectCategory={() => null} // callback is	disabled but prop is required
			/>

			<VendorsTable
				editPath={''}
				isGeneric={true}
				isGettingData={false}
				vendors={getGenericVendorsData()}
			/>
		</React.Fragment>
	);
}
